module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAMAAABhTZc9AAAAM1BMVEX////////////////////////////////////////////////////////////////////lEOhHAAAAEHRSTlMAECAwQFBgcICQoLDA0ODwVOCoyAAAAQdJREFUGBltwQmChCAMAMEOh0YIJv9/7So691bxlFbbI2Lva+JbsdjbWkrR5tEz76SHFR6qxcZL3r3wbvUh3LIP4VMeQ5hkH8I32QdTd+FXduVQovKfNRJgxkmYSm+JRTjsDVJUTiNzqHHwljgsDqszhVfA4uSJg0SlNyaPsCVZnDLTUIYyWbxw2YwoTPHiXNSIwrTFU+eiRlQuHg8LFzVMuVjcBrfWaZ2LNI+TZ25DWZxJao+TZ24pMhILh2IxtcSD7kDbmdKiWhNP4gqkWPnP5sJBI/NricpknvmWvXGR4ZlPizcepIcKL7JF483qrolL2twrH0Q9RlPVvseuwo+i3czamnn6A8YCDdXEFkHJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/006-twitter.png
// module id = 208
// module chunks = 4